import { XIcon } from 'components';
import "./NavigationButtons.css";

const NavigationButtons = ({callbackLeft, callbackRight, rightDisabled}) => {

  return (
    <div  className="button-container">
      <button className="left-button" onClick={callbackLeft}>
        <XIcon />
      </button>
      <button className="right-button" onClick={callbackRight} disabled={rightDisabled}>
        ✓
      </button>
    </div>
  )
};

export { NavigationButtons };